import React from 'react';
import { Resource } from './types';
import ResourceCard from './ResourceCard.tsx';

interface ResourceGridProps {
  resources: Resource[];
  onOpenFile: (url: string) => void;
}

const ResourceGrid: React.FC<ResourceGridProps> = ({ resources, onOpenFile }) => {
  const styles = {
    resourcesGrid: {
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))',
      gap: '24px'
    },
    noResults: {
      backgroundColor: 'white',
      borderRadius: '8px',
      boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)',
      padding: '32px',
      textAlign: 'center' as const
    }
  };

  if (resources.length === 0) {
    return (
      <div style={styles.noResults}>
        <h3 style={{ fontSize: '1.125rem', fontWeight: '500', color: '#1f2937', marginBottom: '8px' }}>
          No resources found
        </h3>
        <p className="p-style" style={{ color: '#6b7280' }}>
          Try adjusting your filters or search terms
        </p>
      </div>
    );
  }

  return (
    <div style={styles.resourcesGrid}>
      {resources.map((resource, index) => (
        <ResourceCard 
          key={index} 
          resource={resource} 
          onOpenFile={onOpenFile} 
        />
      ))}
    </div>
  );
};

export default ResourceGrid;